export default function WorkLiveIntegration() {
  const benefits = [
    {
      icon: 'ri-home-4-line',
      title: '住居の提供',
      description: '旧寮や宿舎を改修し、快適な従業員住宅として提供',
      details: ['個室または家族向け住居', '家賃補助制度', '家具・家電付き']
    },
    {
      icon: 'ri-walk-line',
      title: '通勤時間ゼロ',
      description: '職場と住居が同じ敷地内にあり、通勤の負担がありません',
      details: ['徒歩数分の通勤', '時間の有効活用', 'ワークライフバランス']
    },
    {
      icon: 'ri-community-line',
      title: 'コミュニティ形成',
      description: '共用スペースで従業員同士の交流を促進',
      details: ['共用ラウンジ', '食堂・カフェ', 'イベントスペース']
    },
    {
      icon: 'ri-shopping-bag-line',
      title: '生活サポート',
      description: '移住者の生活立ち上げを全面的にサポート',
      details: ['生活必需品の手配', '地域情報の提供', '行政手続き支援']
    }
  ];

  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#E8F5E9] mb-6">
            <i className="ri-home-heart-line text-[#2D7A3E] text-lg mr-2"></i>
            <span className="text-[#2D7A3E] text-sm font-semibold whitespace-nowrap">働く場所と住む場所の統合</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-6">
            仕事も生活も<br />
            ここで完結
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            廃校の寮や宿舎を改修し、従業員住宅として提供。<br />
            働く場所と住む場所を同時に提供することで、移住のハードルを下げ、<br />
            地域への定着を促進します。
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-[#F5F9F6] to-white p-6 rounded-xl border border-[#E8F5E9] hover:shadow-lg transition-all duration-300 text-center"
            >
              <div className="w-14 h-14 bg-[#2D7A3E] rounded-lg flex items-center justify-center mb-4 mx-auto">
                <i className={`${benefit.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#1A2332] mb-3">{benefit.title}</h3>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">{benefit.description}</p>
              <div className="space-y-2 inline-flex flex-col items-start">
                {benefit.details.map((detail, idx) => (
                  <div key={idx} className="flex items-center">
                    <div className="w-1.5 h-1.5 bg-[#2D7A3E] rounded-full mr-2"></div>
                    <span className="text-xs text-gray-600">{detail}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}